/* nt-portfolio.js — centralized portfolio project data + filter lists.
   Business filter = the 8 main sign categories (slugs match nt-sign-data.js);
   sign type filter = the 38 sign types offered on the category pages.
   Consumed by templates/page.nt-portfolio.json. */
window.NT = window.NT || {};

(function (NT) {
  var ITEMS = [
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3-D-ACRYLIC-FRONTLIT-SIGN-2_c2d35a92-aeb1-45ea-a2dc-20c3815961f3.png?v=1786517531",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "storefront-lighted-signs",
      "typeL": "Storefront Lighted Signs",
      "title": "3D acrylic front lit sign",
      "alt": "3D acrylic front lit sign | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3-D-ACRYLIC-FRONTLIT-SIGN-2_c2d35a92-aeb1-45ea-a2dc-20c3815961f3.png?v=1786517531",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d-acrylic-frontlit-sign-4_45928331-7212-49ed-99f1-16d6c6f8ea31.png?v=1786517543",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3-D-ACRYLIC-FRONLIT-SIGN-1_61208cde-6656-4167-93db-258f93b561b0.png?v=1786517551",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d-acrylic-fronlit-sign-3_351859e7-e12b-44df-8578-c1004aa079ac.png?v=1786517559"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/laser-cut-sign-1.png?v=1786517620",
      "cat": "gyms",
      "catL": "3D Metal Backlit Signs / Halo Lit Signage",
      "type": "3d-hollow-cut-backlit-sign",
      "typeL": "3D Hollow Cut Backlit Sign",
      "title": "3D hollow cut backlit logo",
      "alt": "3D hollow cut backlit logo | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/laser-cut-sign-1.png?v=1786517620",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/laser-cut-sign-2.png?v=1786517629",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/laser-cut-sign-3_4eae3029-8020-4574-a764-25df7752ca41.png?v=1786953113"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Intricate_Laser-Cut_Metal_Gym_Sign.jpg?v=1788347562",
      "cat": "restaurants",
      "catL": "Interior Signs / Interior Business Signage",
      "type": "laser-cut-signs",
      "typeL": "Laser Cut Signs",
      "title": "Laser cut feature wall",
      "alt": "Laser cut feature wall | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Intricate_Laser-Cut_Metal_Gym_Sign.jpg?v=1788347562",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Premium_Gym_Acrylic_Laser-Cut_Panel.jpg?v=1788347561",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Dimensional_Laser-Cut_Gym_Letters.jpg?v=1788347561",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Laser-Cut_Wood_Acrylic_Gym_Sign.jpg?v=1788347561"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Premium_Dealership_Night_Exterior_Halo_Sign.jpg?v=1788348168",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "3d-metal-backlit-signs",
      "typeL": "3D Metal Backlit Signs",
      "title": "3D metal backlit building sign",
      "alt": "3D metal backlit building sign | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Premium_Dealership_Night_Exterior_Halo_Sign.jpg?v=1788348168",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Automotive_Service_Center_Large_Back-Lit_Wall_Sign.jpg?v=1788348169",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Modern_Auto_Showroom_Logo_Back-Lit_Letters.jpg?v=1788348168",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Luxury_Dealership_Individual_Back-Lit_Letters.jpg?v=1788348135"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Boutique_Fitness_Studio_Flat-Cut_Metal_Lettering.jpg?v=1788349992",
      "cat": "restaurants",
      "catL": "Interior Signs / Interior Business Signage",
      "type": "flat-cut-signs",
      "typeL": "Flat Cut Signs",
      "title": "Flat cut wall lettering",
      "alt": "Flat cut wall lettering | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Boutique_Fitness_Studio_Flat-Cut_Metal_Lettering.jpg?v=1788349992",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Modern_Strength_Studio_Bold_Flat-Cut_Lettering.jpg?v=1788349992",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Premium_Pilates_Wellness_Studio_Flat-Cut_Brass_Lettering.jpg?v=1788349992"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit-3_02fa16cb-0553-410b-9411-a8129a17e53e.png?v=1786517702",
      "cat": "restaurants",
      "catL": "Interior Signs / Interior Business Signage",
      "type": "3d-metal-backlit-signs",
      "typeL": "3D Metal Backlit Signs",
      "title": "3D metal backlit lobby logo",
      "alt": "3D metal backlit lobby logo | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit_4206f6dd-346d-4069-857f-1a2190666628.png?v=1786517694",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit-2_5abc5319-657f-4bda-bece-d42eea5748e1.png?v=1786517685",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit-3_02fa16cb-0553-410b-9411-a8129a17e53e.png?v=1786517702"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/38ba9ab6feabea78269fb32802ad89d8.jpg?v=1788351993",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "3d-acrylic-double-lit",
      "typeL": "3D Acrylic Double Lit",
      "title": "3D acrylic double lit sign",
      "alt": "3D acrylic double lit sign | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/38ba9ab6feabea78269fb32802ad89d8.jpg?v=1788351993",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/049f32df91de07cae41e89653d849a51.jpg?v=1788351992",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Boutique_Restaurant_Double-Lit_Acrylic_Sign_on_Interior_Feature_Wall.jpg?v=1788351994"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit-4_4cfd5939-135a-4207-8f24-e729ab90bd5b.png?v=1786517711",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "3d-metal-backlit-signs",
      "typeL": "3D Metal Backlit Signs",
      "title": "3D metal backlit sign",
      "alt": "3D metal backlit sign | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit_4206f6dd-346d-4069-857f-1a2190666628.png?v=1786517694",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit-2_5abc5319-657f-4bda-bece-d42eea5748e1.png?v=1786517685",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit-4_4cfd5939-135a-4207-8f24-e729ab90bd5b.png?v=1786517711"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/PUSH-THROUGH-SIGN-2_2a61bef0-4722-4ebd-888c-5949e9f8e14b.png?v=1786517778",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "push-through-sign",
      "typeL": "Push Through Sign",
      "title": "Push through sign",
      "alt": "Push through sign | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/PUSH-THOUGH-SIGN-1_c84765cc-bbd0-4063-8889-5cfa404be4cb.png?v=1786517787",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/PUSH-THROUGH-SIGN-2_2a61bef0-4722-4ebd-888c-5949e9f8e14b.png?v=1786517778",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/PUSH-THROUGH-SIGN-3_d3eefd2e-5d89-4fc2-b8f4-6ed0bbe4a477.png?v=1786517795"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d-acrylic-frontlit-sign-4_45928331-7212-49ed-99f1-16d6c6f8ea31.png?v=1786517543",
      "cat": "face-lit",
      "catL": "Face Lit Signage / Front Lit Signs",
      "type": "face-lit-signs",
      "typeL": "Face Lit Signs",
      "title": "Face lit entry sign",
      "alt": "Face lit entry sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/lightbox-sign-2_f234d207-aed8-4433-bbca-9f85e22a1e12.png?v=1786517813",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "wall-mounted-lightbox",
      "typeL": "Wall Mounted Lightbox",
      "title": "Storefront lightbox sign",
      "alt": "Storefront lightbox sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/lightbox-sign-3_a7b623cf-13f5-4b9a-9d3c-becc3ed3c3d8.png?v=1786517822",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "wall-mounted-lightbox",
      "typeL": "Wall Mounted Lightbox",
      "title": "Exterior lightbox sign",
      "alt": "Exterior lightbox sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/lightbox-sign-4_d35df9ed-c3fd-4fc6-8d76-f39e8a9b8b31.png?v=1786517830",
      "cat": "salons",
      "catL": "Corporate & Restaurant Signs / Commercial Signage",
      "type": "wall-mounted-lightbox",
      "typeL": "Wall Mounted Lightbox",
      "title": "Restaurant lightbox sign",
      "alt": "Restaurant lightbox sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/lightbox-sign-5_30e8144c-3467-4d53-b8a8-fa9b3a052ae8.png?v=1786517857",
      "cat": "lightbox",
      "catL": "Lightbox Signage / Cabinet Signs",
      "type": "wall-mounted-lightbox",
      "typeL": "Wall Mounted Lightbox",
      "title": "Wall mounted lightbox sign",
      "alt": "Wall mounted lightbox sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3-D-ACRYLIC-FRONLIT-SIGN-1_61208cde-6656-4167-93db-258f93b561b0.png?v=1786517551",
      "cat": "channel",
      "catL": "Illuminated  Channel Letters / Raceway Signage",
      "type": "illuminated-channel-letters",
      "typeL": "Illuminated  Channel Letters",
      "title": "Showroom front lit sign",
      "alt": "Showroom front lit sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal-backlit-5_d878b94d-0468-4d61-bf84-f8634d9d3c96.png?v=1786517866",
      "cat": "gyms",
      "catL": "3D Metal Backlit Signs / Halo Lit Signage",
      "type": "3d-metal-backlit-signs",
      "typeL": "3D Metal Backlit Signs",
      "title": "3D metal backlit logo",
      "alt": "3D metal backlit logo | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/PUSH-THROUGH-SIGN-3_d3eefd2e-5d89-4fc2-b8f4-6ed0bbe4a477.png?v=1786517795",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "push-through-sign",
      "typeL": "Push Through Sign",
      "title": "Storefront push through sign",
      "alt": "Storefront push through sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d-acrylic-fronlit-sign-3_351859e7-e12b-44df-8578-c1004aa079ac.png?v=1786517559",
      "cat": "face-lit",
      "catL": "Face Lit Signage / Front Lit Signs",
      "type": "face-lit-signs",
      "typeL": "Face Lit Signs",
      "title": "Face lit logo sign",
      "alt": "Face lit logo sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/2d-acrylic-1.png?v=1786517874",
      "cat": "restaurants",
      "catL": "Interior Signs / Interior Business Signage",
      "type": "laser-cut-signs",
      "typeL": "Laser Cut Signs",
      "title": "Laser cut reception sign",
      "alt": "Laser cut reception sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/2d-acrylic-2.png?v=1786517891",
      "cat": "restaurants",
      "catL": "Interior Signs / Interior Business Signage",
      "type": "laser-cut-signs",
      "typeL": "Laser Cut Signs",
      "title": "Laser cut wall sign",
      "alt": "Laser cut wall sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/METAL-BACKLIT-WITH-BACKBOARD.png?v=1786517917",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "3d-metal-backlit-with-backboard-raceway",
      "typeL": "3D Metal Backlit with Backboard/Raceway",
      "title": "3D metal backlit sign on backboard",
      "alt": "3D metal backlit sign on backboard | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic-double-lit-sign-3_150d8efa-4984-4579-9952-ff4f744e426e.png?v=1786517769",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "3d-acrylic-double-lit",
      "typeL": "3D Acrylic Double Lit",
      "title": "Boutique 3D acrylic double lit sign",
      "alt": "Boutique 3D acrylic double lit sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Premium_Fashion_Store_3D_Metal_Storefront_Sign.jpg?v=1788353899",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "3d-metal-non-lit",
      "typeL": "3D Metal Non Lit",
      "title": "3D non lit storefront sign",
      "alt": "3D non lit storefront sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3-D-METAL-NON-LIT-SIGN-3_08b53cb2-a586-4308-9553-8609b25e3169.jpg?v=1786517940",
      "cat": "salons",
      "catL": "Corporate & Restaurant Signs / Commercial Signage",
      "type": "3d-metal-non-lit",
      "typeL": "3D Metal Non Lit",
      "title": "3D metal non lit logo",
      "alt": "3D metal non lit logo | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3D_Acrylic_FrontLit_Backlit_and_SideLit.jpg?v=1791620955",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "3d-acrylic-frontlit-backlit-and-sidelit",
      "typeL": "3D Acrylic FrontLit, BackLit and SideLit",
      "title": "3D acrylic frontlit, backlit and sidelit",
      "alt": "3D acrylic frontlit, backlit and sidelit | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3D_Non_Lit_with_Backboard.jpg?v=1791620956",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "3d-non-lit-with-backboard",
      "typeL": "3D Non Lit with Backboard",
      "title": "3D non lit with backboard",
      "alt": "3D non lit with backboard | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3D_Acrylic_Backlit_with_BackboardRaceway_fc20c4bc-58fb-471e-96a3-c886cc3d266d.jpg?v=1791620955",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "3d-acrylic-backlit-with-backboard-raceway",
      "typeL": "3D Acrylic Backlit with Backboard/Raceway",
      "title": "3D acrylic backlit with backboard/raceway",
      "alt": "3D acrylic backlit with backboard/raceway | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Fabricated_Sign.jpg?v=1791620949",
      "cat": "storefronts",
      "catL": "Storefront Signs / Outdoor Building Signage",
      "type": "fabricated-sign",
      "typeL": "Fabricated Sign",
      "title": "Fabricated sign",
      "alt": "Fabricated sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Acrylic_Front-Lit_Signs_9fb71565-ca1c-4056-8219-c7e6fe5ec8ed.jpg?v=1791622353",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "3d-acrylic-front-lit",
      "typeL": "3D Acrylic Front Lit",
      "title": "3D acrylic front lit",
      "alt": "3D acrylic front lit | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Double_Sided_Lightbox.png?v=1791622358",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "double-sided-lightbox",
      "typeL": "Double Sided Lightbox",
      "title": "Double sided lightbox",
      "alt": "Double sided lightbox | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Channel_Letters_on_Raceway.jpg?v=1791622354",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "channel-letters-on-raceway",
      "typeL": " Channel Letters on Raceway",
      "title": " Channel Letters on raceway",
      "alt": " Channel Letters on raceway | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Exterior_Lighted_Signs.jpg?v=1791622355",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "exterior-lighted-signs",
      "typeL": "Exterior Lighted Signs",
      "title": "Exterior lighted signs",
      "alt": "Exterior lighted signs | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Commercial_Exterior_Signs.jpg?v=1791622351",
      "cat": "medical",
      "catL": "Outdoor Signs / Exterior Signage",
      "type": "commercial-exterior-signs",
      "typeL": "Commercial Exterior Signs",
      "title": "Commercial exterior signs",
      "alt": "Commercial exterior signs | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Illuminated_Hanging_Sign.png?v=1791622627",
      "cat": "restaurants",
      "catL": "Interior Signs / Interior Business Signage",
      "type": "illuminated-hanging-sign",
      "typeL": "Illuminated Hanging Sign",
      "title": "Illuminated hanging sign",
      "alt": "Illuminated hanging sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Custom_Stainless_Steel_Signs.jpg?v=1791622624",
      "cat": "restaurants",
      "catL": "Interior Signs / Interior Business Signage",
      "type": "custom-stainless-steel-signs",
      "typeL": "Custom Stainless Steel Signs",
      "title": "Custom stainless steel signs",
      "alt": "Custom stainless steel signs | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Commercial_Light_Up_Signs.jpg?v=1791623101",
      "cat": "salons",
      "catL": "Corporate & Restaurant Signs / Commercial Signage",
      "type": "commercial-light-up-signs",
      "typeL": "Commercial Light Up Signs",
      "title": "Commercial light up signs",
      "alt": "Commercial light up signs | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Commercial_Fabricated_Sign.jpg?v=1791623098",
      "cat": "salons",
      "catL": "Corporate & Restaurant Signs / Commercial Signage",
      "type": "commercial-fabricated-sign",
      "typeL": "Commercial Fabricated Sign",
      "title": "Commercial fabricated sign",
      "alt": "Commercial fabricated sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Indoor_Backlit_Signs.jpg?v=1791623597",
      "cat": "gyms",
      "catL": "3D Metal Backlit Signs / Halo Lit Signage",
      "type": "indoor-3d-backlit-signs",
      "typeL": "Indoor 3D Backlit Signs",
      "title": "Indoor 3D backlit signs",
      "alt": "Indoor 3D backlit signs | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Backlit_Sign_with_Raceway_one.jpg?v=1791623598",
      "cat": "gyms",
      "catL": "3D Metal Backlit Signs / Halo Lit Signage",
      "type": "3d-backlit-sign-with-raceway",
      "typeL": "3D Backlit Sign with Raceway",
      "title": "3D backlit sign with raceway",
      "alt": "3D backlit sign with raceway | Signmakerz.com",
      "gallery": [
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Backlit_Sign_with_Raceway_one.jpg?v=1791623598",
        "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Backlit_Sign_with_Raceway_two.jpg?v=1791623598"
      ]
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Metal_Outdoor_Business_Signs.jpg?v=1791623598",
      "cat": "gyms",
      "catL": "3D Metal Backlit Signs / Halo Lit Signage",
      "type": "3d-metal-outdoor-business-signs",
      "typeL": "3D Metal Outdoor Business Signs",
      "title": "3D metal outdoor business signs",
      "alt": "3D metal outdoor business signs | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Illuminated_Cabinet_Sign.png?v=1791623776",
      "cat": "lightbox",
      "catL": "Lightbox Signage / Cabinet Signs",
      "type": "illuminated-cabinet-sign",
      "typeL": "Illuminated Cabinet Sign",
      "title": "Illuminated cabinet sign",
      "alt": "Illuminated cabinet sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Custom_Lightbox_Signage.png?v=1791623776",
      "cat": "lightbox",
      "catL": "Lightbox Signage / Cabinet Signs",
      "type": "custom-lightbox-signage",
      "typeL": "Custom Lightbox Signage",
      "title": "Custom lightbox signage",
      "alt": "Custom lightbox signage | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3D_Lightbox_Signage.png?v=1791623775",
      "cat": "lightbox",
      "catL": "Lightbox Signage / Cabinet Signs",
      "type": "3d-lightbox-signage",
      "typeL": "3D Lightbox Signage",
      "title": "3D lightbox signage",
      "alt": "3D lightbox signage | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Front_Lit_with_Backboard.png?v=1791624070",
      "cat": "face-lit",
      "catL": "Face Lit Signage / Front Lit Signs",
      "type": "front-lit-with-backboard",
      "typeL": "Front Lit with Backboard",
      "title": "Front lit with backboard",
      "alt": "Front lit with backboard | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3D_Front_Lit_Signage.jpg?v=1791624066",
      "cat": "face-lit",
      "catL": "Face Lit Signage / Front Lit Signs",
      "type": "3d-front-lit-signage",
      "typeL": "3D Front Lit Signage",
      "title": "3D front lit signage",
      "alt": "3D front lit signage | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Front_Lit_and_Back_Lit_Sign.jpg?v=1791624067",
      "cat": "face-lit",
      "catL": "Face Lit Signage / Front Lit Signs",
      "type": "front-lit-and-3d-backlit-sign",
      "typeL": "Front Lit and 3D Backlit Sign",
      "title": "Front lit and 3D backlit sign",
      "alt": "Front lit and 3D backlit sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/All_Lit_Sign.jpg?v=1791624066",
      "cat": "face-lit",
      "catL": "Face Lit Signage / Front Lit Signs",
      "type": "all-lit-sign",
      "typeL": "All Lit Sign",
      "title": "All lit sign",
      "alt": "All lit sign | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Halo_Lit_Channel_Letters.jpg?v=1791624179",
      "cat": "channel",
      "catL": "Illuminated  Channel Letters / Raceway Signage",
      "type": "halo-lit-channel-letters",
      "typeL": "Halo Lit  Channel Letters",
      "title": "Halo lit  Channel Letters",
      "alt": "Halo lit  Channel Letters | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3D_Channel_Letters.jpg?v=1791624179",
      "cat": "channel",
      "catL": "Illuminated  Channel Letters / Raceway Signage",
      "type": "3d-channel-letters",
      "typeL": "3D  Channel Letters",
      "title": "3D  Channel Letters",
      "alt": "3D  Channel Letters | Signmakerz.com"
    },
    {
      "img": "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3D_Metal_Backlit_with_Backboard.png?v=1791622628",
      "cat": "channel",
      "catL": "Illuminated  Channel Letters / Raceway Signage",
      "type": "3d-metal-letters-with-backboard",
      "typeL": "3D Metal Letters with Backboard",
      "title": "3D metal letters with backboard",
      "alt": "3D metal letters with backboard | Signmakerz.com"
    }
  ];

  var BUSINESS_FILTERS = [
    [
      "all",
      "All work"
    ],
    [
      "storefronts",
      "Storefront Signs / Outdoor Building Signage"
    ],
    [
      "medical",
      "Outdoor Signs / Exterior Signage"
    ],
    [
      "restaurants",
      "Interior Signs / Interior Business Signage"
    ],
    [
      "salons",
      "Corporate & Restaurant Signs / Commercial Signage"
    ],
    [
      "gyms",
      "3D Metal Backlit Signs / Halo Lit Signage"
    ],
    [
      "lightbox",
      "Lightbox Signage / Cabinet Signs"
    ],
    [
      "face-lit",
      "Face Lit Signage / Front Lit Signs"
    ],
    [
      "channel",
      "Illuminated  Channel Letters / Raceway Signage"
    ]
  ];
  var TYPE_FILTERS = [
    [
      "all",
      "All types"
    ],
    [
      "3d-acrylic-frontlit-backlit-and-sidelit",
      "3D Acrylic FrontLit, BackLit and SideLit"
    ],
    [
      "3d-metal-backlit-signs",
      "3D Metal Backlit Signs"
    ],
    [
      "wall-mounted-lightbox",
      "Wall Mounted Lightbox"
    ],
    [
      "3d-metal-non-lit",
      "3D Metal Non Lit"
    ],
    [
      "push-through-sign",
      "Push Through Sign"
    ],
    [
      "3d-metal-backlit-with-backboard-raceway",
      "3D Metal Backlit with Backboard/Raceway"
    ],
    [
      "3d-acrylic-double-lit",
      "3D Acrylic Double Lit"
    ],
    [
      "3d-non-lit-with-backboard",
      "3D Non Lit with Backboard"
    ],
    [
      "storefront-lighted-signs",
      "Storefront Lighted Signs"
    ],
    [
      "3d-acrylic-backlit-with-backboard-raceway",
      "3D Acrylic Backlit with Backboard/Raceway"
    ],
    [
      "fabricated-sign",
      "Fabricated Sign"
    ],
    [
      "3d-acrylic-front-lit",
      "3D Acrylic Front Lit"
    ],
    [
      "double-sided-lightbox",
      "Double Sided Lightbox"
    ],
    [
      "channel-letters-on-raceway",
      " Channel Letters on Raceway"
    ],
    [
      "exterior-lighted-signs",
      "Exterior Lighted Signs"
    ],
    [
      "commercial-exterior-signs",
      "Commercial Exterior Signs"
    ],
    [
      "flat-cut-signs",
      "Flat Cut Signs"
    ],
    [
      "laser-cut-signs",
      "Laser Cut Signs"
    ],
    [
      "illuminated-hanging-sign",
      "Illuminated Hanging Sign"
    ],
    [
      "custom-stainless-steel-signs",
      "Custom Stainless Steel Signs"
    ],
    [
      "commercial-light-up-signs",
      "Commercial Light Up Signs"
    ],
    [
      "commercial-fabricated-sign",
      "Commercial Fabricated Sign"
    ],
    [
      "indoor-3d-backlit-signs",
      "Indoor 3D Backlit Signs"
    ],
    [
      "3d-backlit-sign-with-raceway",
      "3D Backlit Sign with Raceway"
    ],
    [
      "3d-metal-outdoor-business-signs",
      "3D Metal Outdoor Business Signs"
    ],
    [
      "3d-hollow-cut-backlit-sign",
      "3D Hollow Cut Backlit Sign"
    ],
    [
      "illuminated-cabinet-sign",
      "Illuminated Cabinet Sign"
    ],
    [
      "custom-lightbox-signage",
      "Custom Lightbox Signage"
    ],
    [
      "3d-lightbox-signage",
      "3D Lightbox Signage"
    ],
    [
      "face-lit-signs",
      "Face Lit Signs"
    ],
    [
      "front-lit-with-backboard",
      "Front Lit with Backboard"
    ],
    [
      "3d-front-lit-signage",
      "3D Front Lit Signage"
    ],
    [
      "front-lit-and-3d-backlit-sign",
      "Front Lit and 3D Backlit Sign"
    ],
    [
      "all-lit-sign",
      "All Lit Sign"
    ],
    [
      "illuminated-channel-letters",
      "Illuminated  Channel Letters"
    ],
    [
      "halo-lit-channel-letters",
      "Halo Lit  Channel Letters"
    ],
    [
      "3d-channel-letters",
      "3D  Channel Letters"
    ],
    [
      "3d-metal-letters-with-backboard",
      "3D Metal Letters with Backboard"
    ]
  ];

  NT.Portfolio = {
    all: function () {
      return ITEMS.map(function (item, i) { return Object.assign({ index: i }, item); });
    },
    byIndex: function (i) {
      return ITEMS[i] ? Object.assign({ index: i }, ITEMS[i]) : null;
    },
    businessFilters: function () { return BUSINESS_FILTERS.map(function (f) { return { id: f[0], label: f[1] }; }); },
    typeFilters: function () { return TYPE_FILTERS.map(function (f) { return { id: f[0], label: f[1] }; }); }
  };
})(window.NT);
